import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "tagsContainer"]

  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.addTag()
    }
  }

  addTag() {
    const value = this.inputTarget.value.trim()

    if (value === "") return

    // Create tag element
    const tagHTML = `
      <span class="inline-flex items-center justify-center rounded-md border border-[#E4E5E8] bg-white font-medium text-[#1F2937] h-6 pl-2 pr-1 py-0.5 text-sm gap-0.5" data-controller="tag">
        ${value}
        <button type="button" class="w-4 h-4 p-0.5 rounded-sm flex items-center justify-center text-[#6B7280] hover:bg-[#FAFAFB] hover:text-[#4B5563] cursor-pointer" data-action="click->tag#close">
          <svg class="w-full h-full" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6L6 18M6 6L18 18"/>
          </svg>
        </button>
      </span>
    `

    // Insert before input
    this.inputTarget.insertAdjacentHTML("beforebegin", tagHTML)

    // Clear input
    this.inputTarget.value = ""

    // Focus input to keep typing
    this.inputTarget.focus()
  }

  removeTag(event) {
    const tag = event.currentTarget.closest("span")
    if (tag) {
      tag.remove()
    }
  }
}
